import {Component} from '@angular/core';
import {roles} from "../../../../../shared/constants/common.constants";
import {CommonService} from "../../../../../shared/services/common.service";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import {FetchConsentFormLinkRequest, FetchConsentStatusRequest} from "../../../../core/authentication.actions";
import {Subject, takeUntil} from "rxjs";
import {consentFormLink} from "../../../../core/authentication.selectors";
import {Router} from "@angular/router";

@Component({
  selector: 'app-step-four-right-panel',
  templateUrl: './step-four-right-panel.component.html',
  styleUrls: ['./step-four-right-panel.component.css']
})
export class StepFourRightPanelComponent {
  private readonly onDestroy: Subject<any> = new Subject<any>();
  protected readonly roles = roles;
  userRole: number;
  consentFormLink;

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private router: Router
  ) {
    this.store.dispatch(FetchConsentFormLinkRequest({payload: {}}));

    this.store.select(consentFormLink)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.consentFormLink = data['link'];
      });
  }

  linkClick() {
    location.href = this.consentFormLink;
    // this.commonService.openConfirmationDialog({
    //   data: {
    //     message: 'Would you like to Consent?',
    //     submitText: 'Yes',
    //     handleSubmit: () => {
    //       this.commonService.closeDialog();
    //       this.store.dispatch(FetchConsentStatusRequest());
    //     },
    //     cancelText: 'No',
    //     handleCancel: () => {
    //       this.commonService.closeDialog()
    //     }
    //   }
    // })
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
